/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_B2_DescInputs */

const en_pol_scenario_b2_desc = /** @type {(inputs: Pol_Scenario_B2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The official agent in a per-user cloud space you sign in to yourself. Not offered.`)
};

const id_pol_scenario_b2_desc = /** @type {(inputs: Pol_Scenario_B2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen resmi di ruang cloud per pengguna, kamu login sendiri. Tidak ditawarkan.`)
};

/**
* | output |
* | --- |
* | "The official agent in a per-user cloud space you sign in to yourself. Not offered." |
*
* @param {Pol_Scenario_B2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_b2_desc = /** @type {((inputs?: Pol_Scenario_B2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_B2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_b2_desc(inputs)
	return en_pol_scenario_b2_desc(inputs)
});